// import React, { useState } from "react";
// import {
//   Box,
//   TextField,
//   Button,
//   Typography,
//   Paper,
//   CircularProgress,
// } from "@mui/material";
// import ApiServices from "../Utils/ApiServices";

// const LoginPage = () => {
//   const [formData, setFormData] = useState({
//     identifier: "",
//     password: "",
//   });

//   const [loading, setLoading] = useState(false);
//   const [error, setError] = useState("");

//   const handleChange = (e) => {
//     setFormData((prev) => ({
//       ...prev,
//       [e.target.name]: e.target.value,
//     }));
//   };

// const handleLogin = async () => {
//   setError("");

//   if (!formData.identifier || !formData.password) {
//     setError("Please enter all fields");
//     return;
//   }

//   try {
//     setLoading(true);

//     const payload = {
//       client_id: process.env.REACT_APP_CLIENT_ID,
//       identifier: formData.identifier,
//       password: formData.password,
//     };

//     // 🔐 LOGIN API
//     const response = await ApiServices.post(
//       "/api/v1/customers/login/",
//       payload
//     );

//     const data = response?.data;

//     const token = data?.token;
//     const customerId = data?.customer_id;

//     // ✅ Store login data
//     localStorage.setItem("access_token", token);
//     localStorage.setItem("refresh", data?.refresh);
//     localStorage.setItem("customer_id", customerId);
//     localStorage.setItem("is_logged", "true");
//     localStorage.setItem("user_data", JSON.stringify(data));

//     // 🛒 CALL CART API (after login)
//     try {
//       const cartRes = await ApiServices.get(
//         `/api/v1/customers/${customerId}/cart/`,
//         {
//           Authorization: `Bearer ${token}`, // as per your rule
//         }
//       );

//       const cartData = cartRes?.data;

//       // ✅ Store cart id
//       localStorage.setItem("cart_id", cartData?.id);

//       // Optional: store full cart
//       localStorage.setItem("cart_data", JSON.stringify(cartData));
//     } catch (cartErr) {
//       console.log("Cart API failed:", cartErr);
//       // Don't block login if cart fails
//     }

//     // 🚀 Redirect
//     window.location.href = "/dashboard";
//   } catch (err) {
//     console.log(err);

//     if (err?.response?.status === 401) {
//       setError("Invalid credentials");
//     } else if (err?.response?.status === 403) {
//       setError("Account is inactive");
//     } else {
//       setError("Something went wrong. Please try again.");
//     }
//   } finally {
//     setLoading(false);
//   }
// };

//   return (
//     <Box
//       sx={{
//         height: "100vh",
//         display: "flex",
//         justifyContent: "center",
//         alignItems: "center",
//         background: "#f5f5f5",
//       }}
//     >
//       <Paper
//         elevation={3}
//         sx={{
//           padding: 4,
//           width: 350,
//           borderRadius: 3,
//         }}
//       >
//         <Typography variant="h5" mb={2} textAlign="center">
//           Login
//         </Typography>

//         <TextField
//           fullWidth
//           label="Email or Phone"
//           name="identifier"
//           value={formData.identifier}
//           onChange={handleChange}
//           margin="normal"
//         />

//         <TextField
//           fullWidth
//           label="Password"
//           type="password"
//           name="password"
//           value={formData.password}
//           onChange={handleChange}
//           margin="normal"
//         />

//         {error && (
//           <Typography color="error" fontSize={14} mt={1}>
//             {error}
//           </Typography>
//         )}

//         <Button
//           fullWidth
//           variant="contained"
//           sx={{ mt: 2 }}
//           onClick={handleLogin}
//           disabled={loading}
//         >
//           {loading ? <CircularProgress size={24} /> : "Login"}
//         </Button>
//       </Paper>
//     </Box>
//   );
// };

// export default LoginPage;



import React, { useState } from "react";
import {
  Box,
  TextField,
  Button,
  Typography,
  Paper,
  CircularProgress,
  InputAdornment,
  IconButton,
  Stack,
  Divider,
  Alert,
  useMediaQuery,
  useTheme,
} from "@mui/material";
import { motion, AnimatePresence } from "framer-motion";
import RestaurantMenuIcon from "@mui/icons-material/RestaurantMenu";
import EmailIcon from "@mui/icons-material/Email";
import LockIcon from "@mui/icons-material/Lock";
import VisibilityIcon from "@mui/icons-material/Visibility";
import VisibilityOffIcon from "@mui/icons-material/VisibilityOff";
import LocalPizzaIcon from "@mui/icons-material/LocalPizza";
import LocalDiningIcon from "@mui/icons-material/LocalDining";
import ApiServices from "../Utils/ApiServices";
import { useNavigate } from "react-router-dom";

const REDGRAD = "linear-gradient(135deg, #7A0E0E 0%, #B71C1C 50%, #E64A19 100%)";
const AMBERGRAD = "linear-gradient(135deg, #FF8F00 0%, #FFB300 50%, #FFC107 100%)";

const LoginPage = () => {
  const theme = useTheme();
  const isMobile = useMediaQuery(theme.breakpoints.down("md"));
const navigate = useNavigate();
  const [formData, setFormData] = useState({ identifier: "", password: "" });
  const [loading, setLoading] = useState(false);
  const [error, setError] = useState("");
  const [showPassword, setShowPassword] = useState(false);

  const handleChange = (e) => {
    setFormData((prev) => ({ ...prev, [e.target.name]: e.target.value }));
  };

  const handleLogin = async () => {
    setError("");

    if (!formData.identifier || !formData.password) {
      setError("Please enter all fields");
      return;
    }

    try {
      setLoading(true);

      const payload = {
        client_id: process.env.REACT_APP_CLIENT_ID,
        identifier: formData.identifier,
        password: formData.password,
      };

      const response = await ApiServices.post("/api/v1/customers/login/", payload);
      const data = response?.data;
      const token = data?.token;
      const customerId = data?.customer_id;

      localStorage.setItem("access_token", token);
      localStorage.setItem("refresh", data?.refresh);
      localStorage.setItem("customer_id", customerId);
      localStorage.setItem("is_logged", "true");
      localStorage.setItem("user_data", JSON.stringify(data));

      try {
        const cartRes = await ApiServices.get(
          `/api/v1/customers/${customerId}/cart/`,
          { Authorization: `Bearer ${token}` }
        );
        const cartData = cartRes?.data;
        localStorage.setItem("cart_id", cartData?.id);
        localStorage.setItem("cart_data", JSON.stringify(cartData));
      } catch (cartErr) {
        console.log("Cart API failed:", cartErr);
      }

      window.location.href = "/menu";
    } catch (err) {
      console.log(err);
      if (err?.response?.status === 401) setError("Invalid credentials");
      else if (err?.response?.status === 403) setError("Account is inactive");
      else setError("Something went wrong. Please try again.");
    } finally {
      setLoading(false);
    }
  };

  const handleKey = (e) => {
    if (e.key === "Enter") handleLogin();
  };

  return (
    <Box
      sx={{
        minHeight: "100vh",
        display: "flex",
        position: "relative",
        overflow: "hidden",
        background:
          "radial-gradient(1200px 600px at 10% 0%, rgba(255,179,0,0.18), transparent 60%), radial-gradient(900px 500px at 90% 100%, rgba(230,74,25,0.22), transparent 60%), #FFF8F0",
      }}
    >
      {/* Ambient floating blobs */}
      <Box
        sx={{
          position: "absolute",
          top: "-10%",
          left: "-5%",
          width: 400,
          height: 400,
          borderRadius: "50%",
          background: "radial-gradient(circle, rgba(183,28,28,0.25), transparent 70%)",
          filter: "blur(60px)",
          animation: "lp-float-1 14s ease-in-out infinite",
          pointerEvents: "none",
        }}
      />
      <Box
        sx={{
          position: "absolute",
          bottom: "-15%",
          right: "-5%",
          width: 500,
          height: 500,
          borderRadius: "50%",
          background: "radial-gradient(circle, rgba(255,179,0,0.3), transparent 70%)",
          filter: "blur(70px)",
          animation: "lp-float-2 18s ease-in-out infinite",
          pointerEvents: "none",
        }}
      />

      {/* Left brand panel (desktop only) */}
      {!isMobile && (
        <Box
          sx={{
            flex: 1,
            position: "relative",
            background: REDGRAD,
            display: "flex",
            alignItems: "center",
            justifyContent: "center",
            p: 6,
            overflow: "hidden",
          }}
        >
          <Box
            sx={{
              position: "absolute",
              inset: 0,
              background:
                "radial-gradient(circle at 30% 20%, rgba(255,179,0,0.35), transparent 50%), radial-gradient(circle at 70% 80%, rgba(255,255,255,0.15), transparent 50%)",
            }}
          />
          {/* Floating food icons */}
          <motion.div
            animate={{ y: [0, -20, 0], rotate: [0, 10, 0] }}
            transition={{ duration: 6, repeat: Infinity, ease: "easeInOut" }}
            style={{ position: "absolute", top: "15%", right: "20%" }}
          >
            <LocalPizzaIcon sx={{ fontSize: 80, color: "rgba(255,255,255,0.25)" }} />
          </motion.div>
          <motion.div
            animate={{ y: [0, 20, 0], rotate: [0, -8, 0] }}
            transition={{ duration: 7, repeat: Infinity, ease: "easeInOut" }}
            style={{ position: "absolute", bottom: "20%", left: "15%" }}
          >
            <LocalDiningIcon sx={{ fontSize: 70, color: "rgba(255,255,255,0.2)" }} />
          </motion.div>

          <motion.div
            initial={{ opacity: 0, y: 30 }}
            animate={{ opacity: 1, y: 0 }}
            transition={{ duration: 0.8 }}
            style={{ position: "relative", zIndex: 1, textAlign: "center", maxWidth: 480 }}
          >
            <Box
              sx={{
                width: 100,
                height: 100,
                borderRadius: "50%",
                background: AMBERGRAD,
                display: "flex",
                alignItems: "center",
                justifyContent: "center",
                margin: "0 auto 24px",
                animation: "lp-pulse-ring 2.5s infinite",
                boxShadow: "0 12px 40px rgba(0,0,0,0.3)",
              }}
            >
              <RestaurantMenuIcon sx={{ fontSize: 52, color: "#fff" }} />
            </Box>
            <Typography
              sx={{
                fontFamily: "'Playfair Display', serif",
                fontWeight: 800,
                fontSize: { md: 48, lg: 60 },
                color: "#fff",
                lineHeight: 1.1,
                mb: 2,
                textShadow: "0 4px 20px rgba(0,0,0,0.3)",
              }}
            >
              Welcome Back, Foodie!
            </Typography>
            <Typography
              sx={{
                color: "rgba(255,255,255,0.9)",
                fontSize: 18,
                fontWeight: 400,
                letterSpacing: 0.5,
              }}
            >
              Sign in to continue your culinary journey — fresh flavors, fast delivery.
            </Typography>
            <Stack direction="row" spacing={1.5} justifyContent="center" sx={{ mt: 4 }}>
              {["Authentic", "Fresh", "Fast"].map((t) => (
                <Box
                  key={t}
                  sx={{
                    px: 2.5,
                    py: 0.8,
                    borderRadius: 999,
                    background: "rgba(255,255,255,0.18)",
                    backdropFilter: "blur(10px)",
                    border: "1px solid rgba(255,255,255,0.25)",
                    color: "#fff",
                    fontSize: 13,
                    fontWeight: 600,
                  }}
                >
                  {t}
                </Box>
              ))}
            </Stack>
          </motion.div>
        </Box>
      )}

      {/* Right form panel */}
      <Box
        sx={{
          flex: 1,
          display: "flex",
          alignItems: "center",
          justifyContent: "center",
          p: { xs: 2, sm: 4 },
          position: "relative",
          zIndex: 1,
        }}
      >
        <motion.div
          initial={{ opacity: 0, y: 30 }}
          animate={{ opacity: 1, y: 0 }}
          transition={{ duration: 0.6, delay: 0.1 }}
          style={{ width: "100%", maxWidth: 440 }}
        >
          <Paper
            elevation={0}
            sx={{
              p: { xs: 3, sm: 5 },
              borderRadius: 5,
              background: "rgba(255,255,255,0.85)",
              backdropFilter: "blur(20px)",
              border: "1px solid rgba(255,255,255,0.6)",
              boxShadow:
                "0 20px 60px rgba(183,28,28,0.15), 0 8px 20px rgba(0,0,0,0.06)",
            }}
          >
            {/* Mobile logo */}
            {isMobile && (
              <Box sx={{ textAlign: "center", mb: 3 }}>
                <Box
                  sx={{
                    width: 72,
                    height: 72,
                    borderRadius: "50%",
                    background: REDGRAD,
                    display: "inline-flex",
                    alignItems: "center",
                    justifyContent: "center",
                    boxShadow: "0 8px 24px rgba(183,28,28,0.4)",
                    mb: 1.5,
                  }}
                >
                  <RestaurantMenuIcon sx={{ fontSize: 38, color: "#fff" }} />
                </Box>
              </Box>
            )}

            <Typography
              sx={{
                fontFamily: "'Playfair Display', serif",
                fontWeight: 800,
                fontSize: { xs: 28, sm: 34 },
                background: REDGRAD,
                WebkitBackgroundClip: "text",
                WebkitTextFillColor: "transparent",
                textAlign: "center",
                mb: 0.5,
              }}
            >
              Sign In
            </Typography>
            <Typography
              sx={{
                textAlign: "center",
                color: "#6b4a3a",
                fontSize: 14.5,
                mb: 3.5,
              }}
            >
              Hungry? Let's get you back to the good stuff 🍕
            </Typography>

            <Stack spacing={2.2}>
              <TextField
                fullWidth
                label="Email or Phone"
                name="identifier"
                value={formData.identifier}
                onChange={handleChange}
                onKeyDown={handleKey}
                InputProps={{
                  startAdornment: (
                    <InputAdornment position="start">
                      <EmailIcon sx={{ color: "#B71C1C" }} />
                    </InputAdornment>
                  ),
                }}
                sx={{
                  "& .MuiOutlinedInput-root": {
                    borderRadius: 3,
                    background: "rgba(255,248,240,0.6)",
                    "&:hover fieldset": { borderColor: "#E64A19" },
                    "&.Mui-focused fieldset": {
                      borderColor: "#B71C1C",
                      borderWidth: 2,
                    },
                  },
                  "& label.Mui-focused": { color: "#B71C1C" },
                }}
              />

              <TextField
                fullWidth
                label="Password"
                type={showPassword ? "text" : "password"}
                name="password"
                value={formData.password}
                onChange={handleChange}
                onKeyDown={handleKey}
                InputProps={{
                  startAdornment: (
                    <InputAdornment position="start">
                      <LockIcon sx={{ color: "#B71C1C" }} />
                    </InputAdornment>
                  ),
                  endAdornment: (
                    <InputAdornment position="end">
                      <IconButton
                        onClick={() => setShowPassword((s) => !s)}
                        edge="end"
                        size="small"
                      >
                        {showPassword ? <VisibilityOffIcon /> : <VisibilityIcon />}
                      </IconButton>
                    </InputAdornment>
                  ),
                }}
                sx={{
                  "& .MuiOutlinedInput-root": {
                    borderRadius: 3,
                    background: "rgba(255,248,240,0.6)",
                    "&:hover fieldset": { borderColor: "#E64A19" },
                    "&.Mui-focused fieldset": {
                      borderColor: "#B71C1C",
                      borderWidth: 2,
                    },
                  },
                  "& label.Mui-focused": { color: "#B71C1C" },
                }}
              />

              <Box sx={{ textAlign: "right" }}>
                <Typography
                  component="a"
                  href="#"
                  sx={{
                    fontSize: 13,
                    fontWeight: 600,
                    color: "#B71C1C",
                    textDecoration: "none",
                    "&:hover": { textDecoration: "underline" },
                  }}
                >
                  Forgot password?
                </Typography>
              </Box>

              <AnimatePresence>
                {error && (
                  <motion.div
                    initial={{ opacity: 0, y: -10, height: 0 }}
                    animate={{ opacity: 1, y: 0, height: "auto" }}
                    exit={{ opacity: 0, y: -10, height: 0 }}
                  >
                    <Alert
                      severity="error"
                      sx={{
                        borderRadius: 2.5,
                        fontWeight: 500,
                        background: "rgba(211,47,47,0.08)",
                      }}
                    >
                      {error}
                    </Alert>
                  </motion.div>
                )}
              </AnimatePresence>

              <motion.div whileHover={{ y: -2 }} whileTap={{ scale: 0.97 }}>
                <Button
                  fullWidth
                  onClick={handleLogin}
                  disabled={loading}
                  sx={{
                    py: 1.6,
                    borderRadius: 3,
                    fontSize: 16,
                    fontWeight: 700,
                    color: "#fff",
                    background: REDGRAD,
                    boxShadow: "0 12px 30px rgba(183,28,28,0.4)",
                    backgroundSize: "200% 200%",
                    transition: "all 0.4s ease",
                    "&:hover": {
                      boxShadow: "0 18px 40px rgba(183,28,28,0.55)",
                      backgroundPosition: "100% 0%",
                    },
                    "&.Mui-disabled": { color: "rgba(255,255,255,0.7)" },
                  }}
                >
                  {loading ? (
                    <CircularProgress size={24} sx={{ color: "#fff" }} />
                  ) : (
                    "Sign In"
                  )}
                </Button>
              </motion.div>

              <Divider sx={{ my: 1, color: "#9c7a6a", fontSize: 12 }}>
                New to Pizza Town?
              </Divider>

              <Button
  fullWidth
  variant="outlined"
  onClick={() => navigate("/signup")}
  sx={{
    py: 1.4,
    borderRadius: 3,
    fontWeight: 700,
    fontSize: 15,
    borderColor: "#B71C1C",
    borderWidth: 2,
    color: "#B71C1C",
    "&:hover": {
      borderWidth: 2,
      borderColor: "#7A0E0E",
      background: "rgba(183,28,28,0.05)",
    },
  }}
>
  Create an Account
</Button>
            </Stack>
          </Paper>

          <Typography
            sx={{
              textAlign: "center",
              mt: 3,
              fontSize: 12.5,
              color: "#6b4a3a",
            }}
          >
            By signing in, you agree to our{" "}
            <Box component="span" sx={{ color: "#B71C1C", fontWeight: 600 }}>
              Terms
            </Box>{" "}
            &{" "}
            <Box component="span" sx={{ color: "#B71C1C", fontWeight: 600 }}>
              Privacy Policy
            </Box>
          </Typography>
        </motion.div>
      </Box>
    </Box>
  );
};

export default LoginPage;
